import axios from 'axios';

const baseURL = process.env.REACT_APP_API_URL
const apiClient = axios.create({
    baseURL,
    withCredentials: true,
    timeout: 5000 // 5 seconds
});

export interface CreatePostRequest {
    content: string
    h: string
}

interface mpResponse {
    location: string
}

export const createPost = async (postData: CreatePostRequest) => {
    const mpResp = await apiClient.post(
        "/submit",
        postData
    )
    return mpResp.headers.location
}
